// extracted by mini-css-extract-plugin
export default {"main":"ClosableBox_main__uwaeR","nameContainer":"ClosableBox_nameContainer__+ikEP","name":"ClosableBox_name__UiunD","icon":"ClosableBox_icon__uDOmv"};